import { Component, OnInit } from '@angular/core';
import { AccountService } from './account.service';
import { LoginService } from '../../login/login.service';
import { Router } from '@angular/router';

declare const jQuery: any;
declare var $: any;
declare var toastr: any;

@Component({
  selector: 'account',
  templateUrl: './account.component.html',
  styleUrls: ['../dispatcher.component.css', './account.component.css']
})
export class AccountComponent implements OnInit {
  email: any;
  first_name: any;

  constructor(
    private _router: Router,
    private _AccountService: AccountService
  ) {}

  profile_me() {
    $('.account_loading_parent').show();
    this._AccountService.getProfile({}).subscribe(
      (res: any) => {
        $('.account_loading_parent').hide();
        console.log(res.data);
        this.first_name = res.data.name;
        this.email = res.data.email;
      },
      err => {
        $('.account_loading_parent').hide();
        this.handleStatus(err.status, err.error);
      }
    );
  }

  ngOnInit() {
    this.profile_me();
  }

  handleStatus(statuscode, errMsg) {
    if (statuscode >= 500) {
      statuscode = 500;
    }
    switch (statuscode) {
      case 401:
        this._router.navigate(['login']);
        sessionStorage.clear();
        break;
      case 500:
        toastr['warning']('Could not connect to server');
        break;
      default:
        toastr['warning'](errMsg.message);
        break;
    }
  }
}
